import React from "react";
import { Box, Typography } from "@mui/material";
import { maxWidth, styled, width } from "@mui/system";
// import LoadingImg from "../assets/MobiLogo.jpg";

const Root = styled("div")(({ theme }) => ({
  alignItems: "center",
  backgroundColor: theme.palette.primary.main,
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  justifyContent: "center",
  zIndex: 2000,
}));

const Loader = styled("img")(({ theme }) => ({
  width: 300,
  maxWidth: "100%",
}));

const ProgressBar = styled("div")({
  height: "3px",
});

export default function PageLoading() {
  return (
    <Root>
      <Box sx={{}} align="center">
        <Loader
          src="/images/logo.png"
          alt="loader"
          className="logoimageDash auth_logo"
          style={{ cursor: "pointer", width: "auto", maxWidth: "100px" }}
        />
        <Typography
          variant="h2"
          className="headerText"
          color= "secondary"
          sx={{
            fontWeight: 600,
            textTransform: "uppercase",
            fontSize: {
              xs: "20px !important", // Mobile
              sm: "24px", // Tablets
              md: "28px", // Desktop
            },
          }}
        >
         IRHIS
        </Typography>
      </Box>
    </Root>
  );
}
